import find from 'lodash/find'


export function getLocalFile(state, localFileId) {
  return find(
    state.userSettings.localFiles,
    (x) => x.id === localFileId
  )
}